import { render, staticRenderFns } from "./GeneralSetting.vue?vue&type=template&id=541de069&scoped=true"
import script from "./GeneralSetting.vue?vue&type=script&lang=js"
export * from "./GeneralSetting.vue?vue&type=script&lang=js"
import style0 from "./GeneralSetting.vue?vue&type=style&index=0&id=541de069&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541de069",
  null
  
)

export default component.exports